import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { ISettingType } from "src/services/types";
import { toast } from 'react-toastify';
import { getSettingTypes, updateSettingType } from "src/services/settings-service";
import { columnsSettingTypes } from "./ColumnsSettingTypes";
import { EditRelevanceModal } from "./EditRelevanceModal";

export const SettingTypes = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [settingTypes, setSettingTypes] = useState<ISettingType[]>([]);
  const [settingTypeSelected, setSettingTypeSelected] = useState<ISettingType | null>(null);
  const [showEditRelModal, setShowEditRelModal] = useState(false);

  const getData = async () => {
        setIsLoading(true);
        const res = await getSettingTypes()
        setIsLoading(false);
        if (res.result === 'ok') {
            setSettingTypes(res.data);
        } else {
            toast(res.message, { type: 'error'});
        }
  }
  
  const handleRequired = async (item: ISettingType) => {

    const newSettingTypes = settingTypes.map((sType) => {
        if (sType.id === item.id) {
            return { ...sType, isRequired: !item.isRequired};
        }
        return sType;
    });
    setSettingTypes(newSettingTypes);

    const res = await updateSettingType(item.id, { isRequired: !item.isRequired});
    if (res.result === 'ok') {
        toast('Setting Type updated successfully', { type: 'success'});
    } else {
        toast(res.message, { type: 'error'});
        const newSettingTypes2 = settingTypes.map((sType) => {
            if (sType.id === item.id) {
                return { ...sType, isRequired: item.isRequired };
            }
            return sType;
        });
        setSettingTypes(newSettingTypes2);
    }
  }

  const handleActive = async (item: ISettingType) => {

    const newSettingTypes = settingTypes.map((sType) => {
        if (sType.id === item.id) {
            return { ...sType, active: !item.active};
        }
        return sType;
    });
    setSettingTypes(newSettingTypes);

    const res = await updateSettingType(item.id, { active: !item.active});
    if (res.result === 'ok') {
        toast('Setting Type updated successfully', { type: 'success'});
    } else {
        toast(res.message, { type: 'error'});
        const newSettingTypes2 = settingTypes.map((sType) => {
            if (sType.id === item.id) {
                return { ...sType, active: item.active };
            }
            return sType;
        });
        setSettingTypes(newSettingTypes2);
    }
  }

  const editRelevance = async (item: ISettingType) => {
    setSettingTypeSelected(item);
    setShowEditRelModal(true);
  }
 
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="page-content mb-5 pb-5" style={{height: '100vh'}} >
          <h3 className="mb-4 text-primary">Setting Types</h3>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                  customStyles={{}}
                  columns={columnsSettingTypes(handleRequired, handleActive, editRelevance)}
                  data={settingTypes}
                  pagination
                  responsive
                  paginationPerPage={20}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  noDataComponent={
                      <SectionNoData
                          onRefresh={() => getData()}
                          isLoading={isLoading}
                      />
                  }
              />
          </ContentDataTable>
      </div>

      <EditRelevanceModal
        show={showEditRelModal}
        item={settingTypeSelected}
        onCancel={() => setShowEditRelModal(false)}
        onRefresh={() => getData()}
      />

    </>
  )
}
